import React from 'react'
import './gallery.css'
import Modal from './Modal'

class Gallery extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            filteredTiles: TILES,
            modal: false,
            modalTile: TILES[0],
            modalImg: null,
            modalDescription: null,
            searchReference: '',
            searchBackground: '',
            backgroundColors: ["Blanco", "Gris", "Rojo", "Trani", "Verde"],
            tags: ["Interior", "Exterior", "Grano", "Clasica"]
        }

        this.filterByReference = this.filterByReference.bind(this)
        this.filterByBackground = this.filterByBackground.bind(this)
        this.toogleModal = this.toogleModal.bind(this)
    }
    render() {
        const { modal, modalImg, modalDescription } = this.state;
        return (
            <div className="responsive">
                <Modal src={modalImg} display={modal} description={modalDescription} clickOnModal={this.toogleModal}></Modal>
                <div className="gallery">
                    <div className="filters">
                        <form inline>

                            <label for="reference" className="mr-sm-2">Referencia</label>
                            <input id="reference" type="text" placeholder="referencia" onChange={this.filterByReference} />


                            <label for="selectColor" className="mr-sm-2">Color de Fondo</label>
                            <select type="select" name="select" id="selectColor" onChange={this.filterByBackground} >
                                <option key={99}>Todos</option>
                                {this.state.backgroundColors.map((color, index) => (
                                    <option key={index}>{color}</option>
                                ))}
                            </select>

                        </form>
                    </div>
                    <div className="grid">
                        {this.state.filteredTiles.map((tile, index) => (
                            <div key={index} className="cell">
                                <img
                                    src={"images/tiles/thumbs/" + tile.reference + ".png"}
                                    onClick={e => this.toogleModal(tile.reference, e)}
                                    alt={tile.reference} />
                                <div className="reference">
                                    {"Referencia: " + tile.reference}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        )
    }

    filterByReference(event) {
        const filteredTiles = TILES.filter(tile => tile.reference == event.target.value)
        this.setState({ filteredTiles: filteredTiles.length > 0 ? filteredTiles : TILES })
    }
    filterByBackground(event) {
        const filteredTiles = TILES.filter(tile => tile.background == event.target.value)
        this.setState({ filteredTiles: filteredTiles.length > 0 ? filteredTiles : TILES })
    }

    toogleModal(reference) {
        let self = this;
        this.setState({
            modal: !self.state.modal,
            modalImg: "images/tiles/" + reference + ".png",
            modalDescription: reference
        })
    }


}
/*
<div>Etiquetas: {tile.tags.map((tag) =>(<span>{tag}</span>))}</div>
 */
const TILES = [
    {
        "reference": "1002",
        "background": "Verde",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "trani",
                "size": ""
            },
            {
                "name": "negro",
                "size": ""
            }
        ]
    },
    {
        "reference": "1009",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "negro",
                "size": "3"
            },
            {
                "name": "gris",
                "size": "3"
            },
            {
                "name": "perla",
                "size": "3"
            }
        ]
    },
    {
        "reference": "1010",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1012",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1013",
        "background": "Gris",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },


    {
        "reference": "1019",
        "background": "Trani",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1023",
        "background": "Verde",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1026",
        "background": "Rojo",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1032",
        "background": "Trani",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1037",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1038",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1041",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1044",
        "background": "Gris",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1046",
        "background": "Verde",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1050",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1051",
        "background": "Trani",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1054",
        "background": "Trani",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1060",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1061",
        "background": "Verde",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1067",
        "background": "Trani",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1075",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1080",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1082",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    }
    ,
    {
        "reference": "1083",
        "background": "Gris",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "1102",
        "background": "Trani",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "1014",
                "size": ""
            }
        ]
    },
    {
        "reference": "9000",
        "background": "Trani",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    }
    ,
    {
        "reference": "9999",
        "background": "Blanco",
        "tags": [
            "interior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "2001",
        "background": "Otro",
        "tags": [
            "exterior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "2002",
        "background": "Trani",
        "tags": [
            "exterior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "2003",
        "background": "Trani",
        "tags": [
            "exterior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "2101",
        "background": "Trani",
        "tags": [
            "exterior",
            "grano"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "A0001",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "A0002",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
    {
        "reference": "A0003",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },{
        "reference": "A0004",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },{
        "reference": "A0005",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },{
        "reference": "A0006",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },{
        "reference": "A0007",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },{
        "reference": "A0008",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },{
        "reference": "A0009",
        "background": "",
        "tags": [
            "interior",
            "clasica"
        ],
        "grain": [
            {
                "name": "",
                "size": ""
            }
        ]
    },
]

export default Gallery


// WEBPACK FOOTER //
// ./src/components/gallery/Gallery.jsx